import React from 'react';
import { Inbox } from 'lucide-react';

/**
 * <EmptyState />
 *
 * Friendly empty/zero-state used by DataTable + page-level empty cases.
 * Always carries an icon + title; hint and CTA are optional.
 */
export default function EmptyState({
  icon: Icon = Inbox,
  title = 'Nothing here yet',
  hint,
  cta,
  size = 'md',
}) {
  const iconSize = size === 'sm' ? 'h-8 w-8' : size === 'lg' ? 'h-14 w-14' : 'h-10 w-10';
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-6 text-center" data-testid="gov-empty-state">
      <div className="gov-text-tertiary mb-1 rounded-full bg-[var(--gov-bg-elevated)] p-3">
        <Icon className={iconSize} />
      </div>
      <h3 className="gov-text-primary text-sm font-medium" data-testid="gov-empty-title">{title}</h3>
      {hint && (
        <p className="gov-text-tertiary max-w-md text-xs" data-testid="gov-empty-hint">{hint}</p>
      )}
      {cta && <div className="mt-2">{cta}</div>}
    </div>
  );
}
